import { useState } from 'react';

import { DownloadIcon, IconSize, Tooltip } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';
import { CSVDownloader } from '../../csv/CSVDownloader';

type DownloadCSVIconActionProps = {
   readonly statisticsId: number;
};

export const DownloadCSVIconAction = (props: DownloadCSVIconActionProps): JSX.Element => {
   const [downloading, setDownloading] = useState(false);

   return (
      <Tooltip content={statisticsTranslationKeys.orderTable.actions.downloadAsCsv} testId={'downloadAsCsv'}>
         <>
            <CSVDownloader
               statisticsId={props.statisticsId}
               downloading={downloading}
               onDownloaded={() => setDownloading(false)}
            />
            <DownloadIcon testId={'downloadIcon'} size={IconSize.NORMAL} onClick={() => setDownloading(true)} />
         </>
      </Tooltip>
   );
};
